import { type Step } from '@/stores/steps';

export const start: Step[] = [{ content: 'start', returnable: false, delay: 500, hidePreview: true }];

export const withQualificationSteps: Step[] = [
  {
    content: 'select_product',
    fullHeight: true,
    delay: 500,
    progress: 20,
    scroll: false,
    hidePreviewContainer: true,
    hidePreview: true
  }
];

export const noQualificationSteps: Step[] = [
  {
    content: 'chat_question_request',
    returnable: false,
    merge: true,
    delay: 300,
    hidePreview: true
  },
  {
    content: 'qualification_chat_question_transition',
    merge: true,
    returnable: false,
    timeout: 500,
    hidePreview: true
  },
  {
    content: 'select_product',
    fullHeight: true,
    delay: 500,
    progress: 20,
    scroll: false,
    hidePreviewContainer: true,
    hidePreview: true
  }
];

export const producerDataSteps: Step[] = [
  { content: 'chat_continue', timeout: 500 },
  { content: 'producer_data_question_1', merge: true, timeout: 500 },
  { content: 'producer_data_question_2', merge: true, timeout: 500 },
  { content: 'producer_data_block', skipOnReturn: 4, merge: true, delay: 500 }
];

export const aiSteps: Step[] = [
  {
    content: 'product_details_ai_loading_examples',
    progress: 40,
    returnable: false,
    scroll: false,
    hidePreview: true,
    fullHeight: true
  }
];

export const productDetailsWithIaSteps: Step[] = [
  { content: 'chat_continue', timeout: 500, progress: 40 },
  {
    content: 'product_details_ai_question',
    skipOnReturn: 2,
    returnable: false,
    merge: true,
    timeout: 500,
    progress: 40
  }
];

export const productDetailsWithoutIaSteps: Step[] = [
  { content: 'chat_continue', timeout: 500, progress: 40 },
  { content: 'chat_edit_without_ia', merge: true, returnable: false, timeout: 500, progress: 40 }
];

export const ebookSteps: Step[] = [
  { content: 'chat_continue', timeout: 500, hidePreview: true },
  { content: 'upload_chat_question_1', returnable: false, merge: true, timeout: 500, hidePreview: true },
  {
    content: 'upload_answer_files',
    skipOnReturn: 3,
    returnable: false,
    merge: true,
    delay: 500,
    hidePreview: true,
    progress: 35
  },
  // ai step decides on next steps
  { content: 'product_details_form_block', skipOnReturn: 4, merge: true, returnable: false, delay: 500, scroll: false },
  { content: 'chat_continue', timeout: 500 },
  { content: 'billing_model_question', merge: true, returnable: false, timeout: 500 },
  { content: 'billing_model_product', merge: true, skipOnReturn: 4, returnable: false, delay: 500 },
  { content: 'payment_method_chat_question_1', merge: true, returnable: false, timeout: 500 },
  { content: 'payment_method_answer_info', skipOnReturn: 3, returnable: false, merge: true, delay: 500, scroll: false },
  { content: 'chat_continue', timeout: 500, returnable: false },
  { content: 'chat_review_product', merge: true, timeout: 500, returnable: false },
  { content: 'reviewProduct', returnable: false, merge: true, delay: 500 },
  { content: 'failedMessage', skipOnReturn: 3, merge: true, delay: 500 }
];

export const [_, ...directEbookSteps] = ebookSteps;
